//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchBuildingList } from '@/api/main/slxc';
export default {
  components: {},
  props: {
    visible: {
      bgWidth: '',
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sysList: [],
      GENVisible: false,
      sysType: '',
      mapTitle: '',
      equipmentVisible: false,
      baVisible: false,
      intelligentGuardVisible: false,
      intelligentGuardList: [],
      menuChooseList: [],
      menuList: [// { name: '小区运行', icon: 'xqyxqk', sysTypeValue: 'total' },
      // { name: '智慧井盖', icon: 'znjg' },
      {
        name: 'BA监测',
        icon: 'BA',
        sysTypeValue: 'BA'
      }, {
        name: '智能门禁',
        icon: 'menjin',
        sysTypeValue: 'TFCS'
      }, // { name: '智能信报箱', icon: 'znxbx' },
      // { name: '智能垃圾箱', icon: 'znljx' },
      {
        name: '视频监控',
        icon: 'spjk',
        sysTypeValue: 'SCS'
      }, {
        name: '发电机',
        icon: 'fadianji',
        sysTypeValue: 'GEN'
      }, {
        name: '智能广播',
        icon: 'zngb',
        sysTypeValue: 'IBS'
      }]
    };
  },
  watch: {
    visible: function visible(n, o) {
      if (!n) this.bgWidth.style.top = 0 + 'px';
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {},
    handleSwitchMenu: function handleSwitchMenu(item, index) {
      var _this = this;

      this.bgWidth = document.querySelector('#switchMenu');
      var selfTop = document.querySelectorAll('.menu-item')[index].offsetTop;
      this.bgWidth.style.top = selfTop + 'px';

      if (item.sysTypeValue === 'BA') {
        this.baVisible = true;
      } else if (item.sysTypeValue === 'TFCS') {
        fetchBuildingList({}).then(function (response) {
          _this.intelligentGuardList = response.data.data;

          _this.$nextTick(function () {
            _this.intelligentGuardVisible = true;
          });
        });
      } else if (item.sysTypeValue === 'SCS') {
        this.mapTitle = '视频监控';
        this.sysType = 'SCS';
        this.equipmentVisible = true;
      } else if (item.sysTypeValue === 'GEN') {
        this.mapTitle = '发电机';
        this.GENVisible = true;
      } else if (item.sysTypeValue === 'IBS') {
        this.equipmentVisible = true;
        this.sysType = 'IBS';
        this.mapTitle = '智能广播';
      } // switch (index) {
      //   // case 1 :
      //   //   this.equipmentVisible = true
      //   //   this.sysType = 'WCS'
      //   //   this.mapTitle = '智能井盖'
      //   //   break
      //   case 1 :
      //     this.baVisible = true
      //     break
      //   case 2:
      //     fetchBuildingList({}).then((response) => {
      //       this.intelligentGuardList = response.data.data
      //       this.$nextTick(() => {
      //         this.intelligentGuardVisible = true
      //       })
      //     })
      //     break
      //   // case 4 :
      //   //   this.equipmentVisible = true
      //   //   this.sysType = 'FBOX'
      //   //   this.mapTitle = '智能信报箱'
      //   //   break
      //   // case 5 :
      //   //   this.equipmentVisible = true
      //   //   this.sysType = 'GBRS'
      //   //   this.mapTitle = '智能垃圾箱'
      //   //   break
      //   case 3 :
      //     this.mapTitle = '视频监控'
      //     this.equipmentVisible = true
      //     this.sysType = 'SCS'
      //     break
      //   case 4 :
      //     this.mapTitle = '发电机'
      //     this.GENVisible = true
      //     break
      //   // case 7 :
      //   //   this.equipmentVisible = true
      //   //   this.sysType = 'IBS'
      //   //   this.mapTitle = '智能广播'
      //   //   break
      //   // case 4 :
      //   //   this.equipmentVisible = true
      //   //   this.sysType = 'SLS'
      //   //   this.mapTitle = '智慧路灯'
      //   //   break
      // }

    }
  }
};